import React from 'react';
import { useResource } from '../use-resource';
export const ResourceSubscriber = ({
  children,
  resource,
  options
}) => {
  const result = useResource(resource, options);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(result));
};